import { Text } from "@mantine/core";
import { PropsWithChildren } from "react";

import classes from "./TextSerif.module.css";

import type { TextProps } from "@mantine/core";
import type { FC } from "react";

export type TextSerifProps = PropsWithChildren<Omit<TextProps, "ff">> & {
  component?: any;
  title?: string;
};

export const TextSerif: FC<TextSerifProps> = ({ c = "dimmed", ...props }) => (
  <Text c={c} ff="Serif-Font" classNames={classes} {...props} />
);
